import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { UnivPrefsService } from '_services/univ-prefs.service';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { HelpComponent } from '../../_shared/help/help.component';
import { MatButton } from '@angular/material/button';
import { NgStyle, AsyncPipe } from '@angular/common';
import { PublishPreferencesComponent } from '../publish-preferences/publish-preferences.component';
import { FireFormDirective, FireFormState } from '../../_shared/fire-form.directive';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';

@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.css'],
  imports: [HelpComponent, MatButton, PublishPreferencesComponent, ReactiveFormsModule, FireFormDirective, MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent, MatRadioGroup, MatRadioButton, MatFormField, MatLabel, MatInput, NgStyle, AsyncPipe]
})
export class BrandingComponent implements OnInit {
  brandingForm: UntypedFormGroup;
  documentPath: string;
  state: FireFormState = 'loading';
  logoSize = new BehaviorSubject(null);
  welcomeSize = new BehaviorSubject(null);
  isUploading = new BehaviorSubject(false); // Add loading state

  contentChoice = 'welcomeDisclaimer';
  constructor(
    private titleService: Title,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    public ups: UnivPrefsService
  ) {
    this.titleService.setTitle('Branding' + ' | NPC Admin');
    this.brandingForm = this.fb.group({
      headerType: [''],
      headerColor: [''],
      headerGradient: [''],
      headerBottomBorderStyle: [''],
      backgroundType: [''],
      backgroundColor: [''],
      backgroundGradient: [''],
      panelColor: [''],
      footerColor: [''],
      headerShrink: ['']
    });
    const schoolId = this.route.snapshot.parent?.paramMap.get('schoolId') ?? '';
    this.documentPath = 'preferences_draft/' + schoolId;
  }

  ngOnInit() {
    if (this.headerTypeValue === '') {
      this.brandingForm.controls['headerType'].setValue('hSolid');
    }
    if (this.bkgTypeValue === '') {
      this.brandingForm.controls['backgroundType'].setValue('bgSolid');
    }
  }


  changeHandler(state: FireFormState) {
    this.state = state;
  }

  uploadFile(event: Event, type: 'logo' | 'header' | 'page' | 'welcome') {
    if (event.target instanceof HTMLInputElement) {
      const files = event.target.files as FileList;
      const schoolId = this.route.snapshot.parent?.paramMap.get('schoolId') ?? '';
      const file = files.item(0);
      const size = Math.round(file.size / 1000);

      // Client-side validation (keep existing logic)
      if (type === 'welcome' && size > 2000) {
        alert('The file you are uploading is roughly ' + size + 'k. Please use squoosh.app to get your file under 2000K');
        return;
      } else if (size > 500) {
        alert('The file you are uploading is roughly ' + size + 'k. Please use squoosh.app to get your file under 500K');
        return;
      }

      // Set loading state
      this.isUploading.next(true);

      // Upload the file and handle the result
      this.ups.uploadImageFile(schoolId, file, type).subscribe({
        next: (result) => {
          this.isUploading.next(false);
          if (result.success) {
            // Upload successful - could show a success message if desired
            console.log('Upload successful:', result.message);
          } else {
            // Upload failed - show error message to user
            alert('Upload failed: ' + result.message);
          }
        },
        error: (error) => {
          this.isUploading.next(false);
          // Handle any unexpected errors
          console.error('Unexpected upload error:', error);
          alert('An unexpected error occurred during upload. Please try again.');
        }
      });
    }
  }

  removeImageRef(type: string) {
    const schoolId = this.route.snapshot.parent?.paramMap.get('schoolId') ?? '';
    this.ups.removeImageRef(schoolId, type);
  }

  check(event: Event, type: 'logo' | 'welcome') {
    if (event.target instanceof HTMLImageElement) {
      const image = event.target as HTMLImageElement;
      const size = { width: image.naturalWidth, height: image.naturalHeight };

      switch (type) {
        case 'logo':
          this.logoSize.next(size);
          break;
        case 'welcome':
          this.welcomeSize.next(size);
          break;
      }
    }
  }

  get headerTypeValue(): string {
    return this.brandingForm.controls['headerType'].value;
  }
  get headerGradientValue(): string {
    return this.brandingForm.controls['headerGradient'].value;
  }
  get headerColorValue(): string {
    return this.brandingForm.controls['headerColor'].value;
  }
  get backgroundColorValue(): string {
    return this.brandingForm.controls['backgroundColor'].value;
  }
  get bkgTypeValue(): string {
    return this.brandingForm.controls['backgroundType'].value;
  }
  get bkgGradientValue(): string {
    return this.brandingForm.controls['backgroundGradient'].value;
  }
  get headerBottomBorderValue(): string {
    return this.brandingForm.controls['headerBottomBorderStyle'].value;
  }
  get panelColorValue(): string {
    return this.brandingForm.controls['panelColor'].value;
  }
  get footerColorValue(): string {
    return this.brandingForm.controls['footerColor'].value;
  }

}
